import React from "react";
import ErrorShell, { GoHomeButton } from "./ErrorShell";
export default function AccountSuspended() {
  return <ErrorShell code="🔒" title="Account suspended" message="Your account has been suspended. Please contact AWebBee support to reactivate your access." action={<GoHomeButton label="Back to login" />} />;
}
